import { ErrorHandler, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { FatalError } from "./api.interceptor";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private messageService: MessageService, private router: Router) {}
  handleError(error: any): void {
    if (error instanceof FatalError && error.message != 'Message not available') {
      // Only show API errors
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error.message,
        life: 10000,
      });
      if(error.statusCode === 401) {
        this.router.navigate(['/login']);
      }
    }
   
  }
}
 
